window.AA_WORKSPACE = {
  user: null,
  role: null,
  isInternal: false,
  authResolved: false,
  authLocked: false,
  authLockReason: null,

  clients: [],
  activeClientId: null,

  clientId: null,
  clientName: null,

  playbookId: null,
  month: null,
  year: null
};

window.AAWorkspaceContext = (() => {
  let authSubscription = null;

  function getClient() {
    return window.AASupabaseClient?.getClient?.() || null;
  }

  function resetWorkspaceState() {
    window.AA_WORKSPACE = {
      user: null,
      role: null,
      isInternal: false,
      authResolved: true,
      authLocked: false,
      authLockReason: null,

      clients: [],
      activeClientId: null,

      clientId: null,
      clientName: null,

      playbookId: null,
      month: null,
      year: null
    };

    return window.AA_WORKSPACE;
  }

  async function getWorkspaceAuthContext() {
    const db = getClient();

    if (!db) {
      return {
        user: null,
        role: null,
        isInternal: false,
        clients: [],
        activeClientId: null,
        locked: true,
        lockReason: 'login_unavailable'
      };
    }
    
    const { data } = await db.auth.getSession();

const user = data?.session?.user || null;


    if (!user) {
      return {
        user: null,
        role: null,
        isInternal: false,
        clients: [],
        activeClientId: null,
        locked: false,
        lockReason: null
      };
    }

    const authContext = {
      user,
      role: null,
      isInternal: false,
      clients: [],
      activeClientId: null,
      locked: false,
      lockReason: null
    };

    const { data: internalMember } = await db
      .from("aa_internal_team")
      .select(`
        user_id,
        role_id,
        aa_roles (
          role_key,
          display_name
        )
      `)
      .eq("user_id", user.id)
      .eq("is_active", true)
      .maybeSingle();

    if (internalMember) {
      authContext.isInternal = true;
      authContext.role =
        internalMember.aa_roles?.role_key || "aa_team";

      return authContext;
    }

    const { data: memberships } = await db
      .from("aa_client_memberships")
      .select(`
        client_id,
        role_id,
        aa_roles (
          role_key,
          display_name
        )
      `)
      .eq("user_id", user.id)
      .eq("is_active", true);

    if (!memberships || memberships.length === 0) {
      authContext.locked = true;
      authContext.lockReason = 'no_membership';
      return authContext;
    }

    authContext.clients = memberships.map(member => ({
      clientId: member.client_id,
      role: member.aa_roles?.role_key || "client_employee"
    }));

    authContext.activeClientId =
      authContext.clients[0].clientId;

    authContext.role =
      authContext.clients[0].role;

    return authContext;
  }

async function init({ clientId } = {}) {
  const auth = await getWorkspaceAuthContext();

  const resolvedClientId =
    clientId ||
    auth?.activeClientId ||
    window.AA_CLIENT_ID ||
    null;

  let playbook = null;

  if (
  auth?.user &&
  !auth?.locked &&
  resolvedClientId
) {
  if (auth.isInternal) {
    const db = getClient();

    const { data, error } = await db.functions.invoke(
      'aa-playbook-service',
      {
        body: {
  action: 'ensure-playbook-window',
  clientId: resolvedClientId
}
      }
    );

    if (!error) {
      const response = data?.data || data;

      const playbooks =
        Array.isArray(response?.playbooks)
          ? response.playbooks
          : [];

      const current =
        playbooks.find(
          (item) =>
            Number(item.month) ===
              Number(response?.currentMonth) &&
            Number(item.year) ===
              Number(response?.currentYear)
        );

      if (current) {
        playbook = {
          id: current.id,
          month: current.month,
          year: current.year,
          status: current.status
        };
      }
    }
  } else if (window.AAPlaybookService) {
    playbook =
      await window.AAPlaybookService.getCurrentPlaybook(
        resolvedClientId
      );
  }
}

  window.AA_WORKSPACE = {
    ...window.AA_WORKSPACE,

    user: auth?.user || null,
    role: auth?.role || null,
    isInternal: auth?.isInternal || false,
    authResolved: true,
    authLocked: auth?.locked || false,
    authLockReason: auth?.lockReason || null,

    clients: auth?.clients || [],
    activeClientId: auth?.activeClientId || resolvedClientId,

    clientId: resolvedClientId,
    clientName: null,

    playbookId: playbook?.id || null,
    month: playbook?.month || null,
    year: playbook?.year || null
  };

  return window.AA_WORKSPACE;
}

  function get() {
    return window.AA_WORKSPACE;
  }

  function getLoginRoute() {
    return '/pages/workspace-login';
  }

  function getLockedRoute() {
    return '/pages/workspace-login';
  }

  function getDashboardRoute() {
    const workspace = get();

    if (!workspace?.user) {
      return null;
    }

    if (workspace.authLocked) {
      return getLockedRoute();
    }

    if (workspace.isInternal) {
      return '/pages/artisans-avenue-headquarters';
    }

    if (
      workspace.role === 'client_owner' ||
      workspace.role === 'client_employee'
    ) {
      return '/pages/workspace-dashboard';
    }

    return getLockedRoute();
  }

  function redirectToDashboard() {
    const route = getDashboardRoute();

    if (!route) {
      return;
    }

    if (window.location.pathname !== route) {
      window.location.href = route;
    }
  }

  function redirectToLogin() {
  const route = getLoginRoute();

  if (window.location.pathname !== route) {
    window.location.href = route;
  }
}

  async function signOut() {
    const db = getClient();

    if (db) {
      await db.auth.signOut();
    }

    resetWorkspaceState();
    redirectToLogin();
  }

  function bindAuthStateListener() {
    const db = getClient();

    if (!db || authSubscription) {
      return;
    }

    const { data } = db.auth.onAuthStateChange(async (event, session) => {
      if (!session?.user) {
        resetWorkspaceState();
        return;
      }

      await init();
    });

    authSubscription = data?.subscription || null;
  }

  async function start(options = {}) {
  return init(options);
}

  return {
    start,
    init,
    get,
    getWorkspaceAuthContext,
    getLoginRoute,
    getDashboardRoute,
    redirectToDashboard,
    redirectToLogin,
    signOut
  };
})();